module.exports = __webpack_public_path__ + "img/contact_support_opsz20.474e97b3.svg";